import _ from 'lodash';

import {
  LODESTAR_QUESTION_INPUT_TYPE,
  LODESTAR_QUESTION_VALUE_TYPE,
} from './LodeStarQuestions.constants';

const stringifyAnswerValue = value => {
  if (_.isNil(value)) {
    return '';
  }

  if (_.isBoolean(value)) {
    return value ? 'true' : 'false';
  }

  return String(value);
};

const getQuestionDefaultValue = ({ inputType, defaultValue }) => {
  if (inputType === LODESTAR_QUESTION_INPUT_TYPE.CHECKBOX) {
    return defaultValue === 'true';
  }

  return _.isNil(defaultValue) ? '' : String(defaultValue);
};

const getQuestionStoredValue = ({ question, storedAnswer }) => {
  if (question.inputType === LODESTAR_QUESTION_INPUT_TYPE.CHECKBOX) {
    if (_.isNil(storedAnswer)) {
      return getQuestionDefaultValue(question);
    }

    return stringifyAnswerValue(storedAnswer) === 'true';
  }

  if (_.isNil(storedAnswer)) {
    return getQuestionDefaultValue(question);
  }

  return stringifyAnswerValue(storedAnswer);
};

export const buildInitialFormFromAnswers = ({ questions, answers }) =>
  (questions || []).reduce((acc, question) => {
    acc[question.identifier] = getQuestionStoredValue({
      question,
      storedAnswer: answers?.[question.identifier],
    });

    return acc;
  }, {});

export const serializeAnswersForSave = ({ questions, form }) =>
  (questions || []).reduce((acc, question) => {
    const formValue = form?.[question.identifier];

    if (question.inputType === LODESTAR_QUESTION_INPUT_TYPE.CHECKBOX) {
      acc[question.identifier] = formValue ? 'true' : 'false';

      return acc;
    }

    acc[question.identifier] = stringifyAnswerValue(formValue);

    return acc;
  }, {});

export const getAutocompleteOptions = options =>
  (options || []).map(option => ({ value: option, label: option }));

export const getAutocompleteValue = ({ options, formValue }) => {
  const normalized = stringifyAnswerValue(formValue);

  return (
    (options || [])
      .map(option => ({ value: option, label: option }))
      .find(option => option.value === normalized) ?? null
  );
};

export const isFormDirty = ({ initialForm, currentForm }) => !_.isEqual(initialForm, currentForm);

export const isQuestionFieldChanged = ({ identifier, initialForm, currentForm }) =>
  !_.isEqual(initialForm?.[identifier], currentForm?.[identifier]);

export const getNumericInputProps = ({ question }) => {
  if (question.valueType !== LODESTAR_QUESTION_VALUE_TYPE.NUMBER) {
    return {};
  }

  return { type: 'number', inputMode: 'decimal' };
};
